import { render, staticRenderFns } from "./HoverMenu.vue?vue&type=template&id=2d6ecf8d&"
import script from "./HoverMenu.vue?vue&type=script&lang=js&"
export * from "./HoverMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6ecf8d')) {
      api.createRecord('2d6ecf8d', component.options)
    } else {
      api.reload('2d6ecf8d', component.options)
    }
    module.hot.accept("./HoverMenu.vue?vue&type=template&id=2d6ecf8d&", function () {
      api.rerender('2d6ecf8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/HoverMenu.vue"
export default component.exports